/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Stats_DirectoriesInputs */

const en_directory_external_directories_stats_directories = /** @type {(inputs: Directory_External_Directories_Stats_DirectoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active directories`)
};

const zh_directory_external_directories_stats_directories = /** @type {(inputs: Directory_External_Directories_Stats_DirectoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收录目录`)
};

/**
* | output |
* | --- |
* | "Active directories" |
*
* @param {Directory_External_Directories_Stats_DirectoriesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_stats_directories = /** @type {((inputs?: Directory_External_Directories_Stats_DirectoriesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Stats_DirectoriesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_stats_directories(inputs)
	return zh_directory_external_directories_stats_directories(inputs)
});
export { directory_external_directories_stats_directories as "directory.external_directories.stats_directories" }